import * as fromDatatype from "../datatype-library/index";

export interface ImageJsonInterface extends fromDatatype.JsonDatatypeInterface {
    endDate?: string,
    imageName?: string,
    imageType?: string,
    startDate?: string,
    branch_guid?: string
}

export interface bl_applet_image_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_line_guid: fromDatatype.GuidDataFieldInterface;
    image_type: fromDatatype.VarcharDatatypeInterface;
    image_code: fromDatatype.VarcharDatatypeInterface;
    image_option: fromDatatype.TextDatatypeInterface;
    param_code: fromDatatype.VarcharDatatypeInterface;
    param_name: fromDatatype.VarcharDatatypeInterface;
    param_type: fromDatatype.VarcharDatatypeInterface;
    value_string: fromDatatype.TextDatatypeInterface;
    value_file: fromDatatype.VarcharDatatypeInterface;
    value_numeric: fromDatatype.NumericDatatypeInterface;
    value_datetime: fromDatatype.TimestampTzDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: ImageJsonInterface;
    param_option_json: fromDatatype.JsonDatatypeInterface;
    value_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    seq_no: fromDatatype.BigIntegerDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;    
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_applet_image_hdr_RowClass implements bl_applet_image_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    item_hdr_guid: fromDatatype.GuidDataFieldInterface;
    item_line_guid: fromDatatype.GuidDataFieldInterface;
    image_type: fromDatatype.VarcharDatatypeInterface;
    image_code: fromDatatype.VarcharDatatypeInterface;
    image_option: fromDatatype.TextDatatypeInterface;
    param_code: fromDatatype.VarcharDatatypeInterface;
    param_name: fromDatatype.VarcharDatatypeInterface;
    param_type: fromDatatype.VarcharDatatypeInterface;
    value_string: fromDatatype.TextDatatypeInterface;
    value_file: fromDatatype.VarcharDatatypeInterface;
    value_numeric: fromDatatype.NumericDatatypeInterface;
    value_datetime: fromDatatype.TimestampTzDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: ImageJsonInterface;
    param_option_json: fromDatatype.JsonDatatypeInterface;
    value_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    seq_no: fromDatatype.BigIntegerDatatypeInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;    
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}
